const Vt = ["top", "right", "bottom", "left"], _ = Math.min, k = Math.max, nt = Math.round, et = Math.floor, N = (t) => ({
  x: t,
  y: t
}), _t = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Et(t, e, n) {
  return k(t, _(e, n));
}
function $(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function B(t) {
  return t.split("-")[0];
}
function U(t) {
  return t.split("-")[1];
}
function ht(t) {
  return t === "x" ? "y" : "x";
}
function gt(t) {
  return t === "y" ? "height" : "width";
}
function D(t) {
  const e = t[0];
  return e === "t" || e === "b" ? "y" : "x";
}
function pt(t) {
  return ht(D(t));
}
function Bt(t, e, n) {
  n === void 0 && (n = !1);
  const o = U(t), i = pt(t), s = gt(i);
  let r = i === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return e.reference[s] > e.floating[s] && (r = ot(r)), [r, ot(r)];
}
function zt(t) {
  const e = ot(t);
  return [dt(t), e, dt(e)];
}
function dt(t) {
  return t.includes("start") ? t.replace("start", "end") : t.replace("end", "start");
}
const vt = ["left", "right"], bt = ["right", "left"], It = ["top", "bottom"], Xt = ["bottom", "top"];
function jt(t, e, n) {
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? bt : vt : e ? vt : bt;
    case "left":
    case "right":
      return e ? It : Xt;
    default:
      return [];
  }
}
function Yt(t, e, n, o) {
  const i = U(t);
  let s = jt(B(t), n === "start", o);
  return i && (s = s.map((r) => r + "-" + i), e && (s = s.concat(s.map(dt)))), s;
}
function ot(t) {
  const e = B(t);
  return _t[e] + t.slice(e.length);
}
function qt(t) {
  var e, n, o, i;
  return {
    top: (e = t.top) != null ? e : 0,
    right: (n = t.right) != null ? n : 0,
    bottom: (o = t.bottom) != null ? o : 0,
    left: (i = t.left) != null ? i : 0
  };
}
function Tt(t) {
  return typeof t != "number" ? qt(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function it(t) {
  const {
    x: e,
    y: n,
    width: o,
    height: i
  } = t;
  return {
    width: o,
    height: i,
    top: n,
    left: e,
    right: e + o,
    bottom: n + i,
    x: e,
    y: n
  };
}
function At(t, e, n) {
  let {
    reference: o,
    floating: i
  } = t;
  const s = D(e), r = pt(e), c = gt(r), l = B(e), a = s === "y", h = o.x + o.width / 2 - i.width / 2, d = o.y + o.height / 2 - i.height / 2, m = o[c] / 2 - i[c] / 2;
  let f;
  switch (l) {
    case "top":
      f = {
        x: h,
        y: o.y - i.height
      };
      break;
    case "bottom":
      f = {
        x: h,
        y: o.y + o.height
      };
      break;
    case "right":
      f = {
        x: o.x + o.width,
        y: d
      };
      break;
    case "left":
      f = {
        x: o.x - i.width,
        y: d
      };
      break;
    default:
      f = {
        x: o.x,
        y: o.y
      };
  }
  const u = U(e);
  return u && (f[r] += m * (u === "end" ? 1 : -1) * (n && a ? -1 : 1)), f;
}
async function Kt(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: o,
    y: i,
    platform: s,
    rects: r,
    elements: c,
    strategy: l
  } = t, {
    boundary: a = "clippingAncestors",
    rootBoundary: h = "viewport",
    elementContext: d = "floating",
    altBoundary: m = !1,
    padding: f = 0
  } = $(e, t), u = Tt(f), w = c[m ? d === "floating" ? "reference" : "floating" : d], p = it(await s.getClippingRect({
    element: (n = await (s.isElement == null ? void 0 : s.isElement(w))) == null || n ? w : w.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(c.floating)),
    boundary: a,
    rootBoundary: h,
    strategy: l
  })), x = d === "floating" ? {
    x: o,
    y: i,
    width: r.floating.width,
    height: r.floating.height
  } : r.reference, y = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(c.floating)), b = await (s.isElement == null ? void 0 : s.isElement(y)) && await (s.getScale == null ? void 0 : s.getScale(y)) || {
    x: 1,
    y: 1
  }, A = it(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: c,
    rect: x,
    offsetParent: y,
    strategy: l
  }) : x);
  return {
    top: (p.top - A.top + u.top) / b.y,
    bottom: (A.bottom - p.bottom + u.bottom) / b.y,
    left: (p.left - A.left + u.left) / b.x,
    right: (A.right - p.right + u.right) / b.x
  };
}
const Ut = 50, Gt = async (t, e, n) => {
  const {
    placement: o = "bottom",
    strategy: i = "absolute",
    middleware: s = [],
    platform: r
  } = n, c = r.detectOverflow ? r : {
    ...r,
    detectOverflow: Kt
  }, l = await (r.isRTL == null ? void 0 : r.isRTL(e));
  let a = await r.getElementRects({
    reference: t,
    floating: e,
    strategy: i
  }), {
    x: h,
    y: d
  } = At(a, o, l), m = o, f = 0;
  const u = {};
  for (let g = 0; g < s.length; g++) {
    const w = s[g];
    if (!w)
      continue;
    const {
      name: p,
      fn: x
    } = w, {
      x: y,
      y: b,
      data: A,
      reset: v
    } = await x({
      x: h,
      y: d,
      initialPlacement: o,
      placement: m,
      strategy: i,
      middlewareData: u,
      rects: a,
      platform: c,
      elements: {
        reference: t,
        floating: e
      }
    });
    h = y ?? h, d = b ?? d, u[p] = {
      ...u[p],
      ...A
    }, v && f < Ut && (f++, typeof v == "object" && (v.placement && (m = v.placement), v.rects && (a = v.rects === !0 ? await r.getElementRects({
      reference: t,
      floating: e,
      strategy: i
    }) : v.rects), {
      x: h,
      y: d
    } = At(a, m, l)), g = -1);
  }
  return {
    x: h,
    y: d,
    placement: m,
    strategy: i,
    middlewareData: u
  };
}, Jt = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: o,
      placement: i,
      rects: s,
      platform: r,
      elements: c,
      middlewareData: l
    } = e, {
      element: a,
      padding: h = 0
    } = $(t, e) || {};
    if (a == null)
      return {};
    const d = Tt(h), m = {
      x: n,
      y: o
    }, f = pt(i), u = gt(f), g = await r.getDimensions(a), w = f === "y", p = w ? "top" : "left", x = w ? "bottom" : "right", y = w ? "clientHeight" : "clientWidth", b = s.reference[u] + s.reference[f] - m[f] - s.floating[u], A = m[f] - s.reference[f], v = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(a));
    let O = v ? v[y] : 0;
    (!O || !await (r.isElement == null ? void 0 : r.isElement(v))) && (O = c.floating[y] || s.floating[u]);
    const C = b / 2 - A / 2, T = O / 2 - g[u] / 2 - 1, R = _(d[p], T), J = _(d[x], T), Q = O - g[u] - J, P = O / 2 - g[u] / 2 + C, L = Et(R, P, Q), I = !l.arrow && U(i) != null && P !== L && s.reference[u] / 2 - (P < R ? R : J) - g[u] / 2 < 0, W = I ? P < R ? P - R : P - Q : 0;
    return {
      [f]: m[f] + W,
      data: {
        [f]: L,
        centerOffset: P - L - W,
        ...I && {
          alignmentOffset: W
        }
      },
      reset: I
    };
  }
}), Qt = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: i,
        middlewareData: s,
        rects: r,
        initialPlacement: c,
        platform: l,
        elements: a
      } = e, {
        mainAxis: h = !0,
        crossAxis: d = !0,
        fallbackPlacements: m,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: u = "none",
        flipAlignment: g = !0,
        ...w
      } = $(t, e);
      if ((n = s.arrow) != null && n.alignmentOffset)
        return {};
      const p = B(i), x = D(c), y = B(c) === c, b = await (l.isRTL == null ? void 0 : l.isRTL(a.floating)), A = m || (y || !g ? [ot(c)] : zt(c)), v = u !== "none";
      !m && v && A.push(...Yt(c, g, u, b));
      const O = [c, ...A], C = await l.detectOverflow(e, w), T = [];
      let R = ((o = s.flip) == null ? void 0 : o.overflows) || [];
      if (h && T.push(C[p]), d) {
        const L = Bt(i, r, b);
        T.push(C[L[0]], C[L[1]]);
      }
      if (R = [...R, {
        placement: i,
        overflows: T
      }], !T.every((L) => L <= 0)) {
        var J, Q;
        const L = (((J = s.flip) == null ? void 0 : J.index) || 0) + 1, I = O[L];
        if (I && (!(d === "alignment" ? x !== D(I) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        R.every((E) => D(E.placement) === x ? E.overflows[0] > 0 : !0)))
          return {
            data: {
              index: L,
              overflows: R
            },
            reset: {
              placement: I
            }
          };
        let W = (Q = R.filter((X) => X.overflows[0] <= 0).sort((X, E) => X.overflows[1] - E.overflows[1])[0]) == null ? void 0 : Q.placement;
        if (!W)
          switch (f) {
            case "bestFit": {
              var P;
              const X = (P = R.filter((E) => {
                if (v) {
                  const V = D(E.placement);
                  return V === x || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  V === "y";
                }
                return !0;
              }).map((E) => [E.placement, E.overflows.filter((V) => V > 0).reduce((V, Ht) => V + Ht, 0)]).sort((E, V) => E[1] - V[1])[0]) == null ? void 0 : P[0];
              X && (W = X);
              break;
            }
            case "initialPlacement":
              W = c;
              break;
          }
        if (i !== W)
          return {
            reset: {
              placement: W
            }
          };
      }
      return {};
    }
  };
};
function Ot(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function Rt(t) {
  return Vt.some((e) => t[e] >= 0);
}
const Zt = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: n,
        platform: o
      } = e, {
        strategy: i = "referenceHidden",
        ...s
      } = $(t, e);
      switch (i) {
        case "referenceHidden": {
          const r = await o.detectOverflow(e, {
            ...s,
            elementContext: "reference"
          }), c = Ot(r, n.reference);
          return {
            data: {
              referenceHiddenOffsets: c,
              referenceHidden: Rt(c)
            }
          };
        }
        case "escaped": {
          const r = await o.detectOverflow(e, {
            ...s,
            altBoundary: !0
          }), c = Ot(r, n.floating);
          return {
            data: {
              escapedOffsets: c,
              escaped: Rt(c)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, Pt = /* @__PURE__ */ new Set(["left", "top"]);
async function te(t, e) {
  const {
    placement: n,
    platform: o,
    elements: i
  } = t, s = await (o.isRTL == null ? void 0 : o.isRTL(i.floating)), r = B(n), c = U(n), l = D(n) === "y", a = Pt.has(r) ? -1 : 1, h = s && l ? -1 : 1, d = $(e, t);
  let {
    mainAxis: m,
    crossAxis: f,
    alignmentAxis: u
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return c && typeof u == "number" && (f = c === "end" ? u * -1 : u), l ? {
    x: f * h,
    y: m * a
  } : {
    x: m * a,
    y: f * h
  };
}
const ee = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, o;
      const {
        x: i,
        y: s,
        placement: r,
        middlewareData: c
      } = e, l = await te(e, t);
      return r === ((n = c.offset) == null ? void 0 : n.placement) && (o = c.arrow) != null && o.alignmentOffset ? {} : {
        x: i + l.x,
        y: s + l.y,
        data: {
          ...l,
          placement: r
        }
      };
    }
  };
}, ne = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: o,
        placement: i,
        platform: s
      } = e, {
        mainAxis: r = !0,
        crossAxis: c = !1,
        limiter: l = {
          fn: (x) => {
            let {
              x: y,
              y: b
            } = x;
            return {
              x: y,
              y: b
            };
          }
        },
        ...a
      } = $(t, e), h = {
        x: n,
        y: o
      }, d = await s.detectOverflow(e, a), m = D(i), f = ht(m);
      let u = h[f], g = h[m];
      const w = (x, y) => Et(y + d[x === "y" ? "top" : "left"], y, y - d[x === "y" ? "bottom" : "right"]);
      r && (u = w(f, u)), c && (g = w(m, g));
      const p = l.fn({
        ...e,
        [f]: u,
        [m]: g
      });
      return {
        ...p,
        data: {
          x: p.x - n,
          y: p.y - o,
          enabled: {
            [f]: r,
            [m]: c
          }
        }
      };
    }
  };
}, oe = function(t) {
  return t === void 0 && (t = {}), {
    options: t,
    fn(e) {
      var n, o;
      const {
        x: i,
        y: s,
        placement: r,
        rects: c,
        middlewareData: l
      } = e, {
        offset: a = 0,
        mainAxis: h = !0,
        crossAxis: d = !0
      } = $(t, e), m = {
        x: i,
        y: s
      }, f = D(r), u = ht(f);
      let g = m[u], w = m[f];
      const p = $(a, e), x = typeof p == "number" ? {
        mainAxis: p,
        crossAxis: 0
      } : {
        mainAxis: (n = p.mainAxis) != null ? n : 0,
        crossAxis: (o = p.crossAxis) != null ? o : 0
      };
      if (h) {
        const A = u === "y" ? "height" : "width", v = c.reference[u] - c.floating[A] + x.mainAxis, O = c.reference[u] + c.reference[A] - x.mainAxis;
        g < v ? g = v : g > O && (g = O);
      }
      if (d) {
        var y, b;
        const A = u === "y" ? "width" : "height", v = Pt.has(B(r)), O = c.reference[f] - c.floating[A] + (v && ((y = l.offset) == null ? void 0 : y[f]) || 0) + (v ? 0 : x.crossAxis), C = c.reference[f] + c.reference[A] + (v ? 0 : ((b = l.offset) == null ? void 0 : b[f]) || 0) - (v ? x.crossAxis : 0);
        w < O ? w = O : w > C && (w = C);
      }
      return {
        [u]: g,
        [f]: w
      };
    }
  };
}, ie = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      const {
        placement: n,
        rects: o,
        platform: i,
        elements: s
      } = e, {
        apply: r = () => {
        },
        ...c
      } = $(t, e), l = await i.detectOverflow(e, c), a = B(n), h = U(n), d = D(n) === "y", {
        width: m,
        height: f
      } = o.floating;
      let u, g;
      a === "top" || a === "bottom" ? (u = a, g = h === (await (i.isRTL == null ? void 0 : i.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (g = a, u = h === "end" ? "top" : "bottom");
      const w = f - l.top - l.bottom, p = m - l.left - l.right, x = _(f - l[u], w), y = _(m - l[g], p), b = e.middlewareData.shift, A = !b;
      let v = x, O = y;
      b != null && b.enabled.x && (O = p), b != null && b.enabled.y && (v = w), A && !h && (d ? O = m - 2 * k(l.left, l.right) : v = f - 2 * k(l.top, l.bottom)), await r({
        ...e,
        availableWidth: O,
        availableHeight: v
      });
      const C = await i.getDimensions(s.floating);
      return m !== C.width || f !== C.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function st() {
  return typeof window < "u";
}
function G(t) {
  return Dt(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function S(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function H(t) {
  var e;
  return (e = (Dt(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function Dt(t) {
  return st() ? t instanceof Node || t instanceof S(t).Node : !1;
}
function M(t) {
  return st() ? t instanceof Element || t instanceof S(t).Element : !1;
}
function z(t) {
  return st() ? t instanceof HTMLElement || t instanceof S(t).HTMLElement : !1;
}
function Ct(t) {
  return !st() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof S(t).ShadowRoot;
}
function rt(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: o,
    display: i
  } = F(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + o + n) && i !== "inline" && i !== "contents";
}
function se(t) {
  return /^(table|td|th)$/.test(G(t));
}
function ct(t) {
  try {
    if (t.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return t.matches(":modal");
  } catch {
    return !1;
  }
}
const re = /transform|translate|scale|rotate|perspective|filter/, ce = /paint|layout|strict|content/, j = (t) => !!t && t !== "none";
let at;
function wt(t) {
  const e = M(t) ? F(t) : t;
  return j(e.transform) || j(e.translate) || j(e.scale) || j(e.rotate) || j(e.perspective) || !xt() && (j(e.backdropFilter) || j(e.filter)) || re.test(e.willChange || "") || ce.test(e.contain || "");
}
function le(t) {
  let e = Y(t);
  for (; z(e) && !Z(e); ) {
    if (wt(e))
      return e;
    if (ct(e))
      return null;
    e = Y(e);
  }
  return null;
}
function xt() {
  return at == null && (at = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), at;
}
function Z(t) {
  return /^(html|body|#document)$/.test(G(t));
}
function F(t) {
  return S(t).getComputedStyle(t);
}
function lt(t) {
  return M(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function Y(t) {
  if (G(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    Ct(t) && t.host || // Fallback.
    H(t)
  );
  return Ct(e) ? e.host : e;
}
function Mt(t) {
  const e = Y(t);
  return Z(e) ? (t.ownerDocument || t).body : z(e) && rt(e) ? e : Mt(e);
}
function tt(t, e, n) {
  var o;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const i = Mt(t), s = i === ((o = t.ownerDocument) == null ? void 0 : o.body), r = S(i);
  if (s) {
    const c = mt(r);
    return e.concat(r, r.visualViewport || [], rt(i) ? i : [], c && n ? tt(c) : []);
  } else
    return e.concat(i, tt(i, [], n));
}
function mt(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function Ft(t) {
  const e = F(t);
  let n = parseFloat(e.width) || 0, o = parseFloat(e.height) || 0;
  const i = z(t), s = i ? t.offsetWidth : n, r = i ? t.offsetHeight : o, c = nt(n) !== s || nt(o) !== r;
  return c && (n = s, o = r), {
    width: n,
    height: o,
    $: c
  };
}
function yt(t) {
  return M(t) ? t : t.contextElement;
}
function K(t) {
  const e = yt(t);
  if (!z(e))
    return N(1);
  const n = e.getBoundingClientRect(), {
    width: o,
    height: i,
    $: s
  } = Ft(e);
  let r = (s ? nt(n.width) : n.width) / o, c = (s ? nt(n.height) : n.height) / i;
  return (!r || !Number.isFinite(r)) && (r = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: r,
    y: c
  };
}
const fe = /* @__PURE__ */ N(0);
function Wt(t) {
  const e = S(t);
  return !xt() || !e.visualViewport ? fe : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function ae(t, e, n) {
  return e === void 0 && (e = !1), !!n && e && n === S(t);
}
function q(t, e, n, o) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const i = t.getBoundingClientRect(), s = yt(t);
  let r = N(1);
  e && (o ? M(o) && (r = K(o)) : r = K(t));
  const c = ae(s, n, o) ? Wt(s) : N(0);
  let l = (i.left + c.x) / r.x, a = (i.top + c.y) / r.y, h = i.width / r.x, d = i.height / r.y;
  if (s && o) {
    const m = S(s), f = M(o) ? S(o) : o;
    let u = m, g = mt(u);
    for (; g && f !== u; ) {
      const w = K(g), p = g.getBoundingClientRect(), x = F(g), y = p.left + (g.clientLeft + parseFloat(x.paddingLeft)) * w.x, b = p.top + (g.clientTop + parseFloat(x.paddingTop)) * w.y;
      l *= w.x, a *= w.y, h *= w.x, d *= w.y, l += y, a += b, u = S(g), g = mt(u);
    }
  }
  return it({
    width: h,
    height: d,
    x: l,
    y: a
  });
}
function ft(t, e) {
  const n = lt(t).scrollLeft;
  return e ? e.left + n : q(H(t)).left + n;
}
function kt(t, e) {
  const n = t.getBoundingClientRect(), o = n.left + e.scrollLeft - ft(t, n), i = n.top + e.scrollTop;
  return {
    x: o,
    y: i
  };
}
function ue(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: o,
    strategy: i
  } = t;
  const s = i === "fixed", r = H(o), c = e ? ct(e.floating) : !1;
  if (o === r || c && s)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, a = N(1);
  const h = N(0), d = z(o);
  if ((d || !s) && ((G(o) !== "body" || rt(r)) && (l = lt(o)), d)) {
    const f = q(o);
    a = K(o), h.x = f.x + o.clientLeft, h.y = f.y + o.clientTop;
  }
  const m = r && !d && !s ? kt(r, l) : N(0);
  return {
    width: n.width * a.x,
    height: n.height * a.y,
    x: n.x * a.x - l.scrollLeft * a.x + h.x + m.x,
    y: n.y * a.y - l.scrollTop * a.y + h.y + m.y
  };
}
function de(t) {
  return t.getClientRects ? Array.from(t.getClientRects()) : [];
}
function me(t) {
  const e = lt(t), n = t.ownerDocument.body, o = k(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), i = k(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let s = -e.scrollLeft + ft(t);
  const r = -e.scrollTop;
  return F(n).direction === "rtl" && (s += k(t.clientWidth, n.clientWidth) - o), {
    width: o,
    height: i,
    x: s,
    y: r
  };
}
const he = 25;
function ge(t, e, n) {
  n === void 0 && (n = "viewport");
  const o = n === "layoutViewport", i = S(t), s = H(t), r = i.visualViewport;
  let c = s.clientWidth, l = s.clientHeight, a = 0, h = 0;
  if (r) {
    const m = !xt() || e === "fixed";
    o ? m || (a = -r.offsetLeft, h = -r.offsetTop) : (c = r.width, l = r.height, m && (a = r.offsetLeft, h = r.offsetTop));
  }
  if (ft(s) <= 0) {
    const m = s.ownerDocument, f = m.body, u = getComputedStyle(f), g = m.compatMode === "CSS1Compat" && parseFloat(u.marginLeft) + parseFloat(u.marginRight) || 0, w = Math.abs(s.clientWidth - f.clientWidth - g), p = getComputedStyle(s).scrollbarGutter === "stable both-edges" ? w / 2 : w;
    p <= he && (c -= p);
  }
  return {
    width: c,
    height: l,
    x: a,
    y: h
  };
}
function pe(t, e) {
  const n = q(t, !0, e === "fixed"), o = n.top + t.clientTop, i = n.left + t.clientLeft, s = K(t), r = t.clientWidth * s.x, c = t.clientHeight * s.y, l = i * s.x, a = o * s.y;
  return {
    width: r,
    height: c,
    x: l,
    y: a
  };
}
function St(t, e, n) {
  let o;
  if (e === "viewport" || e === "layoutViewport")
    o = ge(t, n, e);
  else if (e === "document")
    o = me(H(t));
  else if (M(e))
    o = pe(e, n);
  else {
    const i = Wt(t);
    o = {
      x: e.x - i.x,
      y: e.y - i.y,
      width: e.width,
      height: e.height
    };
  }
  return it(o);
}
function we(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let o = tt(t, [], !1).filter((c) => M(c) && G(c) !== "body"), i = null;
  const s = F(t).position === "fixed";
  let r = s ? Y(t) : t;
  for (; M(r) && !Z(r); ) {
    const c = F(r), l = wt(r), a = i ? i.position : s ? "fixed" : "";
    !l && (a === "fixed" || a === "absolute" && c.position === "static") ? o = o.filter((d) => d !== r) : i = c, r = Y(r);
  }
  return e.set(t, o), o;
}
function xe(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: o,
    strategy: i
  } = t;
  const r = [...n === "clippingAncestors" ? ct(e) ? [] : we(e, this._c) : [].concat(n), o], c = St(e, r[0], i);
  let l = c.top, a = c.right, h = c.bottom, d = c.left;
  for (let m = 1; m < r.length; m++) {
    const f = St(e, r[m], i);
    l = k(f.top, l), a = _(f.right, a), h = _(f.bottom, h), d = k(f.left, d);
  }
  return {
    width: a - d,
    height: h - l,
    x: d,
    y: l
  };
}
function ye(t) {
  const {
    width: e,
    height: n
  } = Ft(t);
  return {
    width: e,
    height: n
  };
}
function ve(t, e, n) {
  const o = z(e), i = H(e), s = n === "fixed", r = q(t, !0, s, e);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = N(0);
  if ((o || !s) && ((G(e) !== "body" || rt(i)) && (c = lt(e)), o)) {
    const m = q(e, !0, s, e);
    l.x = m.x + e.clientLeft, l.y = m.y + e.clientTop;
  }
  !o && i && (l.x = ft(i));
  const a = i && !o && !s ? kt(i, c) : N(0), h = r.left + c.scrollLeft - l.x - a.x, d = r.top + c.scrollTop - l.y - a.y;
  return {
    x: h,
    y: d,
    width: r.width,
    height: r.height
  };
}
function ut(t) {
  return F(t).position === "static";
}
function Lt(t, e) {
  if (!z(t) || F(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let n = t.offsetParent;
  return H(t) === n && (n = n.ownerDocument.body), n;
}
function Nt(t, e) {
  const n = S(t);
  if (ct(t))
    return n;
  if (!z(t)) {
    let i = Y(t);
    for (; i && !Z(i); ) {
      if (M(i) && !ut(i))
        return i;
      i = Y(i);
    }
    return n;
  }
  let o = Lt(t, e);
  for (; o && se(o) && ut(o); )
    o = Lt(o, e);
  return o && Z(o) && ut(o) && !wt(o) ? n : o || le(t) || n;
}
const be = async function(t) {
  const e = this.getOffsetParent || Nt, n = this.getDimensions, o = await n(t.floating);
  return {
    reference: ve(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function Ae(t) {
  return F(t).direction === "rtl";
}
const Oe = {
  convertOffsetParentRelativeRectToViewportRelativeRect: ue,
  getDocumentElement: H,
  getClippingRect: xe,
  getOffsetParent: Nt,
  getElementRects: be,
  getClientRects: de,
  getDimensions: ye,
  getScale: K,
  isElement: M,
  isRTL: Ae
};
function $t(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function Re(t, e, n) {
  let o = null, i;
  const s = H(t);
  function r() {
    var h;
    clearTimeout(i), (h = o) == null || h.disconnect(), o = null;
  }
  function c(h, d) {
    h === void 0 && (h = !1), d === void 0 && (d = 1), r();
    const m = t.getBoundingClientRect(), {
      left: f,
      top: u,
      width: g,
      height: w
    } = m;
    if (h || e(), !g || !w)
      return;
    const p = et(u), x = et(s.clientWidth - (f + g)), y = et(s.clientHeight - (u + w)), b = et(f), v = {
      rootMargin: -p + "px " + -x + "px " + -y + "px " + -b + "px",
      threshold: k(0, _(1, d)) || 1
    };
    let O = !0;
    function C(T) {
      const R = T[0].intersectionRatio;
      if (!$t(m, t.getBoundingClientRect()))
        return c();
      if (R !== d) {
        if (!O)
          return c();
        R ? c(!1, R) : i = setTimeout(() => {
          c(!1, 1e-7);
        }, 1e3);
      }
      O = !1;
    }
    try {
      o = new IntersectionObserver(C, {
        ...v,
        // Handle <iframe>s
        root: s.ownerDocument
      });
    } catch {
      o = new IntersectionObserver(C, v);
    }
    o.observe(t);
  }
  const l = S(t), a = () => c(n);
  return l.addEventListener("resize", a), c(!0), () => {
    l.removeEventListener("resize", a), r();
  };
}
function Ce(t, e, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: s = !0,
    elementResize: r = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = o, a = yt(t), h = i || s ? [...a ? tt(a) : [], ...e ? tt(e) : []] : [];
  h.forEach((p) => {
    i && p.addEventListener("scroll", n), s && p.addEventListener("resize", n);
  });
  const d = a && c ? Re(a, n, s) : null;
  let m = -1, f = null;
  r && (f = new ResizeObserver((p) => {
    let [x] = p;
    x && x.target === a && f && e && (f.unobserve(e), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var y;
      (y = f) == null || y.observe(e);
    })), n();
  }), a && !l && f.observe(a), e && f.observe(e));
  let u, g = l ? q(t) : null;
  l && w();
  function w() {
    const p = q(t);
    g && !$t(g, p) && n(), g = p, u = requestAnimationFrame(w);
  }
  return n(), () => {
    var p;
    h.forEach((x) => {
      i && x.removeEventListener("scroll", n), s && x.removeEventListener("resize", n);
    }), d?.(), (p = f) == null || p.disconnect(), f = null, l && cancelAnimationFrame(u);
  };
}
const Se = ee, Le = ne, Ee = Qt, Te = ie, Pe = Zt, De = Jt, Me = oe, Fe = (t, e, n) => {
  const o = /* @__PURE__ */ new Map(), i = n ?? {}, s = {
    ...Oe,
    ...i.platform,
    _c: o
  };
  return Gt(t, e, {
    ...i,
    platform: s
  });
};
export {
  Te as a,
  De as b,
  Fe as c,
  Ce as d,
  Ee as f,
  Pe as h,
  Me as l,
  Se as o,
  Le as s
};
